export const formatAtsCandidate = (candidate = {}, contact = {}) => {
  const { ats_candidate_url, ats_type, social = {} } = candidate;
  const { github_ids = [], linkedin_ids = [], twitter_ids = [] } = social;

  return {
    ...candidate,
    social: {
      github: github_ids[0]
        ? `https://github.com/${github_ids[0]}`
        : contact?.social?.github_url,
      linkedin: linkedin_ids[0]
        ? `https://linkedin.com/in/${linkedin_ids[0]}`
        : contact?.social?.linkedin_url,
      twitter: twitter_ids[0]
        ? `https://twitter.com/${twitter_ids[0]}`
        : contact?.social?.twitter_url,
    },
    ats: {
      greenhouse:
        ats_type === 'greenhouse'
          ? ats_candidate_url
          : contact?.ats?.greenhouse_url,
      lever: ats_type === 'lever' ? ats_candidate_url : contact?.ats?.level_url,
      ashby: ats_type === 'ashby' ? ats_candidate_url : contact?.ats?.ashby_url,
    },
  };
};
